let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("beI6N")).then(() => parcelRequire('Jq3ih'));